<div class="tooltip"
     [attr.title]="description | translate">
    <div class="icon-info_inactive tooltip__icon material-icons">
        {{ icon }}
    </div>
</div>
